import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const syncPatientData = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${Config.workerServerUrl}/bulk-patient-import`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const syncIcdCptData = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${Config.workerServerUrl}/bulk-icd-cpt-import`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const baaAgreementSign = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/practice/baa-agreement-upload`, data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const syncIpaData = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${Config.apiServerUrl}/ipa/bulk_insurance_practice_onboarding_and_patients`, formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchNpiData = async (filter) => {
  const {
    account_id,
    location_id,
    npi
  } = filter;
  try {
    const response = await axios.get(`${Config.apiServerUrl}/ipa/search_npi?account_id=${account_id}&location_id=${location_id}&npi=${npi}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  }  catch (error) {
    return error?.response?.data;
  }
};

export const updateIpaData = async (formData) => {
  try {
    const response = await axios.put(`${Config.apiServerUrl}/ipa-data/update`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
